import PropTypes from 'prop-types';
import React from 'react';
import { AssetsProvider } from '@sitebase/assets-context';
import { publish, subscribe } from '@wh/message-bus';
import American from '@wh/svg-icons/American';
import Chat from '@wh/svg-icons/Chat';
import Contactus from '@wh/svg-icons/Contactus';
import Decimal from '@wh/svg-icons/Decimal';
import Email from '@wh/svg-icons/Email';
import Feedback from '@wh/svg-icons/Feedback';
import Fraction from '@wh/svg-icons/Fraction';
import Greyhounds from '@wh/svg-icons/Greyhounds';
import HelpCircle from '@wh/svg-icons/HelpCircle';
import HorseRacing from '@wh/svg-icons/HorseRacing';
import Podcast from '@wh/svg-icons/Podcast';
import Radio from '@wh/svg-icons/Radio';
import Tv from '@wh/svg-icons/Tv';
import { TranslatorProvider } from '@wh/ui-translations';
import { HEADER_PROPS_UPDATE_REQUESTED, MB_EVENT_HAMBURGER_CLICKED } from '../constants';
import { NewHeader } from './NewHeader';
import { piHeaderRenderers } from './piHeaderRenderers';

export class App extends React.PureComponent {
  state = {
    headerProps: { collapsed: false, shifted: false, hamburgerState: 'inactive' },
  };

  componentDidMount() {
    //initWorkflows({ disableQuickDeposit: !window.kraken.quickDepositEnabled });
    subscribe(HEADER_PROPS_UPDATE_REQUESTED, (topic, headerProps) => {
      this.setState({ headerProps: { ...this.state.headerProps, ...headerProps } });
    });
  }

  onHamburgerClick = () => publish(MB_EVENT_HAMBURGER_CLICKED, {});

  render() {
    const { content, headerConfig, headerRenderers, locale, jurisdiction, buildVertical } = this.props;

    return (
      <TranslatorProvider translations={content}>
        <AssetsProvider resolver={App.assetsProviderResolver}>
          <NewHeader
            buildVertical={buildVertical}
            buildDeviceType={this.props.headerType}
            config={headerConfig}
            content={content}
            jurisdiction={jurisdiction}
            locale={locale}
            renderers={[...headerRenderers, ...piHeaderRenderers]}
          />
        </AssetsProvider>
      </TranslatorProvider>
    );
  }
}

App.propTypes = {
  headerType: PropTypes.string,
  content: PropTypes.shape({}),
  headerConfig: PropTypes.shape({}),
  headerRenderers: PropTypes.arrayOf(PropTypes.shape({})),
};

App.assetsProviderResolver = function assetsProviderResolver(name) {
  const ALLOWED_ICONS = {
    American,
    Chat,
    Contactus,
    Decimal,
    Email,
    Feedback,
    Fraction,
    Greyhounds,
    HelpCircle,
    HorseRacing,
    Podcast,
    Radio,
    Tv,
  };
  return ALLOWED_ICONS[name];
};
